import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { formatOrderDateToLocalTime } from '../../../util/index';
import { getSelectedOrder } from '../../../selectors/tools';
import ProtectedData from 'components/common/ProtectedData/ProtectedData';
import * as sensitiveData from 'constants/sensitiveDataTypes';
import {
  OrderDetailsPage,
  TableTd,
  OrderTable,
  Title,
  TitleImage,
  TitleRow,
  TableTr,
  TableTBody,
  Link,
} from '../OrderDetails.styles';

const NA = 'Not Available';

const formatFulfillmentChannel = (input) => {
  switch (input) {
    case 'MFN':
      return 'Seller';
    case 'AFN':
      return 'Amazon';
    default:
      return input;
  }
};

const AmazonOrderDetailsComponent = ({ selectedOrder }) => {
  // Do not remove, might be used in the future

  // const shippingAddress = selectedOrder['ShippingAddress'];
  // const line1 = shippingAddress && shippingAddress['AddressLine1'];
  // const line2 = shippingAddress && shippingAddress['AddressLine2'];
  // const shippingAddressJSX = shippingAddress ? (
  //   [
  //     <tr key="shipping-info">
  //       <td>Shipping Information</td>
  //       <td />
  //     </tr>,
  //     <tr key="shipping-name">
  //       <td>Name</td>
  //       <td>{shippingAddress['Name'] || NA}</td>
  //     </tr>,
  //     <tr key="shipping-address">
  //       <td>Address</td>
  //       <td>{(line1 && line2 ? `${line1} / ${line2}` : line1) || NA}</td>
  //     </tr>,
  //     <tr key="shipping-city">
  //       <td>City</td>
  //       <td>{shippingAddress['City'] || NA}</td>
  //     </tr>,
  //     <tr key="shipping-state">
  //       <td>Region or state</td>
  //       <td>{shippingAddress['StateOrRegion'] || NA}</td>
  //     </tr>,
  //     <tr key="shipping-postal-code">
  //       <td>Postal Code</td>
  //       <td>{shippingAddress['PostalCode'] || NA}</td>
  //     </tr>,
  //     <tr key="shipping-country-code">
  //       <td>Country Code</td>
  //       <td>{shippingAddress['CountryCode'] || NA}</td>
  //     </tr>,
  //     <tr key="shipping-empty-line">
  //       <td />
  //       <td />
  //     </tr>
  //   ]
  // ) : (
  //   <tr>
  //     <td>Shipping Information</td>
  //     <td>{NA}</td>
  //   </tr>
  // );

  let shipstationTrackingNumberJSX = (
    <TableTr>
      <TableTd>Tracking Number</TableTd>
      <TableTd>{NA}</TableTd>
    </TableTr>
  );

  const shipstationOrder = selectedOrder.shipstationOrder;
  const shipstationOrderTrackingExist = !!((shipstationOrder && shipstationOrder.fulfillments) || []).length;
  if (shipstationOrderTrackingExist) {
    shipstationTrackingNumberJSX = shipstationOrder.fulfillments
      .filter(({ trackingNumber }) => !!trackingNumber)
      .map(({ serviceCode, trackingNumber, carrierCode }, index) => {
        const chosenCarrierCode = carrierCode || shipstationOrder.carrierCode;
        const chosenServiceCode = serviceCode || shipstationOrder.serviceCode;

        return (
          <TableTr key={`shipstationTrackingNumber${trackingNumber}`}>
            <TableTd>{index === 0 ? 'Tracking Number' : ''}</TableTd>
            <TableTd>
              <div>Tracking number: {trackingNumber}</div>
              {carrierCode && <div>Carrier code: "{chosenCarrierCode}"</div>}
              {serviceCode && <div>Service code: "{chosenServiceCode}"</div>}
            </TableTd>
          </TableTr>
        );
      });
  }

  const orderItems = selectedOrder['OrderItems'] || [];
  const orderItemsJSX = orderItems.length ? (
    orderItems.reduce((results, orderItem, index) => {
      const itemPrice = orderItem['ItemPrice'] || {};
      const itemKey = `amazon-order-details-item-${orderItem['OrderItemId']}`;
      const orderItenTsandcsPurl = get(orderItem, 'ServiceTerms.tsandcsPurl', null);
      const orderItenClaimsUrl = get(orderItem, 'ServiceTerms.claimsUrl', null);
      results.push(
        <TableTr key={itemKey}>
          <TableTd>{index === 0 ? 'Line Items' : ''}</TableTd>
          <TableTd>
            {orderItem['QuantityOrdered']} "{orderItem['Title']}": {itemPrice['Amount']} {itemPrice['CurrencyCode']}
          </TableTd>
        </TableTr>
      );
      if (orderItem['OrderItemStatus']) {
        results.push(
          <TableTr key={`${itemKey}-orderItemStatus`}>
            <TableTd />
            <TableTd className="order-item-prop">Status: {orderItem['OrderItemStatus']}</TableTd>
          </TableTr>
        );
      }
      if (orderItem['SellerSKU']) {
        results.push(
          <TableTr key={`${itemKey}-sku`}>
            <TableTd />
            <TableTd className="order-item-prop">SKU: {orderItem['SellerSKU']}</TableTd>
          </TableTr>
        );
      }
      if (orderItem['ASIN']) {
        results.push(
          <TableTr key={`${itemKey}-asin`}>
            <TableTd />
            <TableTd className="order-item-prop">ASIN: {orderItem['ASIN']}</TableTd>
          </TableTr>
        );
      }
      if (orderItem['ShipDate']) {
        results.push(
          <TableTr key={`${itemKey}-ship-date`}>
            <TableTd />
            <TableTd className="order-item-prop">
              Ship Date: {formatOrderDateToLocalTime(orderItem['ShipDate'], 'amazon')}
            </TableTd>
          </TableTr>
        );
      }
      if (orderItem['Carrier']) {
        results.push(
          <TableTr key={`${itemKey}-shipping-carrier`}>
            <TableTd />
            <TableTd className="order-item-prop">Shipping Carrier: {orderItem['Carrier']}</TableTd>
          </TableTr>
        );
      }
      if (orderItem['TrackingNumber'] && !shipstationOrderTrackingExist) {
        results.push(
          <TableTr key={`${itemKey}-tracking`}>
            <TableTd />
            <TableTd className="order-item-prop">Tracking Number: {orderItem['TrackingNumber']}</TableTd>
          </TableTr>
        );
      }
      if (orderItenTsandcsPurl) {
        results.push(
          <TableTr key={`${itemKey}-asin`}>
            <TableTd />
            <TableTd className="order-item-prop">
              Terms of Service Doc Link:&nbsp;
              <Link href={orderItenTsandcsPurl} target="_blank" rel="noopener noreferrer">
                {orderItenTsandcsPurl}
              </Link>
            </TableTd>
          </TableTr>
        );
      }
      if (orderItenClaimsUrl) {
        results.push(
          <TableTr key={`${itemKey}-asin`}>
            <TableTd />
            <TableTd className="order-item-prop">
              Claims Doc Link:&nbsp;
              <Link href={orderItenClaimsUrl} target="_blank" rel="noopener noreferrer">
                {orderItenClaimsUrl}
              </Link>
            </TableTd>
          </TableTr>
        );
      }

      return results;
    }, [])
  ) : (
    <TableTr>
      <TableTd>Line Items</TableTd>
      <TableTd>{NA}</TableTd>
    </TableTr>
  );

  // Check if there is any tracking numbers at all, both shipstation and amazon
  let isAnyTrackingNumberExist = shipstationOrderTrackingExist;
  orderItems.forEach((orderItem) => {
    isAnyTrackingNumberExist = isAnyTrackingNumberExist || orderItem['TrackingNumber'];
  });
  const noTrackingNumbersJSX = (
    <TableTr>
      <TableTd>Tracking Number</TableTd>
      <TableTd>{NA}</TableTd>
    </TableTr>
  );

  const orderTotal = selectedOrder['OrderTotal'];
  const fulfillmentChannel = selectedOrder['FulfillmentChannel'];
  const customerEmail = selectedOrder.BuyerEmail;
  const customerFullName = selectedOrder.BuyerName;
  const firstName = customerFullName && customerFullName.split(' ')[0] ? customerFullName.split(' ')[0] : '';
  const lastName = customerFullName && customerFullName.split(' ')[1] ? customerFullName.split(' ')[1] : '';
  const componentName = 'AmazonOrderDetails';

  return (
    <OrderDetailsPage className="order-details-page">
      <TitleRow className="row title-row">
        <div className="col-xs-12">
          <Title className="title">Order Summary</Title>
          <span>
            <TitleImage className="svg title-image" alt="" src="/images/green-clipboard.svg" />
          </span>
        </div>
      </TitleRow>

      <hr />
      <OrderTable className="order-table">
        <TableTBody>
          <TableTr>
            <TableTd>Order Number</TableTd>
            <TableTd>{selectedOrder['AmazonOrderId'] || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Purchase Date</TableTd>
            <TableTd>{formatOrderDateToLocalTime(selectedOrder['PurchaseDate'], 'amazon')}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Payment Method</TableTd>
            <TableTd>{selectedOrder['PaymentMethod'] || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Fulfillment Channel</TableTd>
            <TableTd>{fulfillmentChannel ? formatFulfillmentChannel(fulfillmentChannel) : NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Sales Channel</TableTd>
            <TableTd>{selectedOrder['SalesChannel'] || NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Customer Name</TableTd>
            <TableTd>
              {!!firstName && firstName}{' '}
              {!!lastName && (
                <ProtectedData
                  data={lastName}
                  dataType={sensitiveData.lastName}
                  placeholder="Click to view last name"
                  component={componentName}
                />
              )}
              {!customerFullName && NA}
            </TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Customer Email</TableTd>
            <TableTd>
              {customerEmail ? (
                <ProtectedData data={customerEmail} dataType={sensitiveData.email} component={componentName} />
              ) : (
                NA
              )}
            </TableTd>
          </TableTr>
          {orderItemsJSX}
          {shipstationOrderTrackingExist && shipstationTrackingNumberJSX}
          {!isAnyTrackingNumberExist && noTrackingNumbersJSX}
          <TableTr>
            <TableTd>Total</TableTd>
            <TableTd>{orderTotal ? `${orderTotal['Amount']} ${orderTotal['CurrencyCode']}` : NA}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Order Status</TableTd>
            <TableTd>{selectedOrder['OrderStatus'] || NA}</TableTd>
          </TableTr>
        </TableTBody>
      </OrderTable>
    </OrderDetailsPage>
  );
};

function mapStateToProps(state) {
  return {
    selectedOrder: getSelectedOrder(state),
  };
}

export default connect(mapStateToProps)(AmazonOrderDetailsComponent);
